import { render, staticRenderFns } from "./VentasListaItemEntregas.vue?vue&type=template&id=159ff39f&"
import script from "./VentasListaItemEntregas.vue?vue&type=script&lang=js&"
export * from "./VentasListaItemEntregas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports